import './bottom-tab-bar.scss';

import { Button } from 'antd';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { MenuOutlined } from '@/media/antd-icons';
import { LocalizedLink } from '@/shared/ui';

import useTabBarItems from './hooks/useTabBarItems';

interface IProps {
  onOpenNav: () => void;
}

/**
 * Нижняя навигация на узком экране: закреплённые разделы, последний открытый
 * и бургер со всеми разделами. Видимость задаётся в CSS.
 */
const BottomTabBar: React.FC<IProps> = ({ onOpenNav }) => {
  const { t } = useTranslation();
  const { items, activeCode } = useTabBarItems();

  return (
    <nav className="bottom-tab-bar" aria-label={t('layout.nav.label')}>
      {items.map(({ code, label, route, icon: Icon }) => (
        <LocalizedLink
          key={code}
          to={route}
          aria-current={code === activeCode ? 'page' : undefined}
          className={classNames('bottom-tab-bar__item', {
            'bottom-tab-bar__item--active': code === activeCode
          })}
        >
          <Icon className="bottom-tab-bar__icon" aria-hidden="true" />
          <span className="bottom-tab-bar__label">{label}</span>
        </LocalizedLink>
      ))}
      <Button
        type="text"
        className="bottom-tab-bar__burger"
        icon={<MenuOutlined className="bottom-tab-bar__icon" />}
        aria-label={t('layout.nav.open')}
        onClick={onOpenNav}
      />
    </nav>
  );
};

export default BottomTabBar;
